module.exports = __webpack_public_path__ + "968aaa24eeffdd779e4fc9c27c5cb730.svg";